import { IngInputBase } from './ing-input-base';
import { IngSelect } from './ing-select';

export class IngSelectChild extends IngInputBase<string> {
  public options: Array<{id: number, text: string, child: [{id: any, text: string}]}>;
  public child: IngSelect;
  public multiple: boolean;
  public classContainerParent: string;

  constructor(
    options: {
      value?: string,
      key?: string,
      label?: string,
      description?: string,
      required?: boolean,
      order?: number,
      options?: Array<{id: number, text: string, child: [{id: any, text: string}]}>,
      multiple?: boolean
      controlType?: string,
      placeHolder?: string,
      classContainer?: string,
      classContainerParent?: string
    } = {},
    optionsChild: {
      value?: string,
      key?: string,
      label?: string,
      required?: boolean,
      order?: number,
      options?: Array<{id: number, text: string}>,
      multiple?: boolean
      controlType?: string,
      placeHolder?: string,
      classContainer?: string
    } = {}    
  ) {
    super(options);

    this.child                = new IngSelect(optionsChild);
    this.options              = options.options || [];
    this.multiple             = options.multiple || false;
    this.classContainerParent = options.classContainerParent || '';
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/inputs/ing-select-child.ts